export class TodoOpenForRfpView {

    id: number;
    dueDate: Date | null;
    adminActiveName: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.dueDate = data?.dueDate ? new Date(data.dueDate) : null
        this.adminActiveName = data?.adminActiveName ?? ""
    }
}
